import React, { useEffect, useState } from "react";
import img from "../../../Images/Rectangle 55.png";
import img1 from "../../../Images/Rectangle 55 (1).png";
import img2 from "../../../Images/Rectangle 55 (2).png";
import img3 from "../../../Images/Rectangle 55 (3).png";
import facebook from "../../../Images/Group 65.png";
import instagram from "../../../Images/Group 66.png";
import thread from "../../../Images/Group 67.png";
import Slider from "react-slick";
import HomeService from "../../../Services/HomeService";
import "./WinnerBlueLan.css";
const WallofFameBlue = () => {
  const [wallOfFame, setWallOfFame] = useState([]);
  
  const fetchWallOfFame = async () => {
    try {
      const res = await HomeService?.getWallOfFame();
      console.log("Wall of fame", res);
      if (res?.status) {
        setWallOfFame(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []);

      const sliderData = [...wallOfFame, ...wallOfFame, ...wallOfFame];


  const settings = {
    dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  cssEase: "linear",
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  pauseOnHover: true,
  swipeToSlide: true,
  draggable: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  // console.log('wallOfframe',wallOfFame);
  // console.log("wall",wallOfFame.length);
  
  return (
    <>
    <div className="wall_of_fame_wrapper_blue">
  <div className="search_cities_div_blue">
    <h1>Winners Wall of Fame</h1>
    <p>
      Top brokers. Big wins. Proud moments — on our Wall of Excellence!
    </p>

    <div className="wall_of_fame_cards_wrapper_blue">
      
      <Slider {...settings}>
        {sliderData?.map((e, i) => (
          <div className="wall_of_fame_card_blue" key={i}>
            <div className="back_social_icons_blue">
              <img src={facebook} alt="Facebook" />
              <img src={instagram} alt="Instagram" />
              <img src={thread} alt="Threads" />
            </div>

            <img
              className="wall_of_fame_img_blue"
              src={e?.image}
              alt={e?.name}
            />

            <div className="wall_of_fame_content_blue">
              <span>{e?.name}</span>
              <small>{e?.designation}</small>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  </div>
</div>
    </>
  );
};

export default WallofFameBlue;
